// @flow
import React from 'react';
import { createUseStyles } from 'react-jss';
import { getHandlerByKey } from 'shared/lib/appHandlers';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  label: string,
  appHandler: string,
  url: string,
  colorTheme: ?string,
  openInNewTab: boolean,
  playVideo: ?Function
}

export default function TransparentButton(props: Props) {
  const { label, appHandler, url, openInNewTab, playVideo } = props;
  const c: { [key: string]: string } = useStyles(props);

  // Assuming reserve, tour, or none - share can be added later
  let handler = getHandlerByKey(appHandler);

  let onClick = playVideo || handler || undefined;

  return (
    <a
      className={props.isV2 ? c.containerV2 : c.container}
      href={!handler ? url : undefined}
      onClick={onClick}
      target={openInNewTab ? '_blank' : undefined}
      rel="noopener noreferrer"
    >
      <span>{label}</span>
    </a>
  );
}

const useStyles = createUseStyles({
  container: {
    padding: '8px 19px',
    border: '1px solid',
    borderRadius: '1px',
    borderColor: ({ colorTheme }) => colorTheme === 'DARK' ? 'rgba(255,255,255,0.33)' : 'black',
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: '14px',
    color: ({ colorTheme }) => colorTheme === 'DARK' ? 'white' : 'black',
    textDecoration: 'none',
    textAlign: 'center',
    minWidth: ({ minWidth }) => minWidth && `${minWidth}`
  },
  containerV2: {
    padding: '8px 16px',
    border: '1px solid',
    borderRadius: '4px',
    borderColor: ({ colorTheme }) => colorTheme === 'DARK' ? 'rgba(255,255,255,0.65)' : 'black',
    fontFamily: FONT_FAMILY_ROBOTO,
    fontWeight: 400,
    lineHeight: '21px',
    width: '264px',
    fontSize: '14px',
    color: ({ colorTheme }) => colorTheme === 'DARK' ? 'white' : 'black',
    textDecoration: 'none',
    textAlign: 'center',
    minWidth: ({ minWidth }) => minWidth && `${minWidth}`
  },
});
